import './VideoModal.scss'
import {Modal} from "antd";
import {ModalCloseIcon} from "../../../../assets/images";
import {generateFileMediaUrl} from "../../../../utils/generateMediaUrl";
import {useEffect, useRef, useState} from "react";
import ReactPlayer from 'react-player'

function VideoModal(props) {
    const {closeModal, visible, item} = props;
    const [videoPlay, setVideoPlay] = useState(true)
    const [closeVideo, setCloseVideo] = useState(false)
    const ref = useRef(null)

    // function videoState(){
    //     let video = document.querySelector('video')
    //     setVideoPlay(false)
    //     video.pause()
    // }

    function toggleModalClose() {
        closeModal()
        // setVideoPlay(true)
        // if (visible) {
        //     // let video = document.querySelector('video')
        //     // video.pause()
        // }
    }

    // console.log(videoPlay,'videoPlay')

    return visible && <Modal
        visible={visible}
        wrapClassName={'video-modal'}
        transitionName={""}
        closeIcon={<ModalCloseIcon/>}
        centered={true}
        maskClosable={true}
        onCancel={toggleModalClose}>
        <div className={'video-modal-wrapper'}>
            {item.youtubeLink ?
                <ReactPlayer src={item.youtubeLink}
                             width={'100%'}
                             height={'100%'}
                             className={'video'}
                             controls={true}
                             config={{
                                 youtube: {
                                     color: 'white',
                                 },
                             }}/> :

                <video playsInline
                       muted
                       ref={ref}
                       autoPlay={true}
                       id={'scrollArea'}
                       controls={videoPlay}
                       src={generateFileMediaUrl(item?.video?.path)}
                    // poster={generateFileMediaUrl(item?.mediaMain?.path)}
                       className={'video'}>

                </video>
            }        </div>
    </Modal>
}

export default VideoModal